































































































  import Vue from 'vue';
  import {ENDPOINTS, get} from "@/api/mainApi";
  import {DonationCase} from "@/interfaces/donation/donationcase/donationCase";
  import DateFieldComponent from "@/components/form/DateFieldComponent.vue";
  import ValidationMixin from '@/mixins/validationMixin';
  import LabelMixin from '@/mixins/labelMixin';

  export default Vue.extend({
    mixins: [ValidationMixin, LabelMixin],
    components: {
      DateFieldComponent
    },
    props: {
      value: {
        type: Object as () => DonationCase,
      },
    },
    data() {
      return {
        query: "",
        timerId: 0,
        recipientLoading: false,
        recipients: [],
      };
    },
    computed: {
      donationCase: {
        get():DonationCase{
          return this.value
        },
        set(val:DonationCase) {
          this.$emit('update:value', val)
        }
      },
    },
    watch: {
      query(val) {
        if (val && val.length > 0) {
          this.getRecipients(val)
        }
      },
    },
    methods: {
      async getRecipients(query: string) {
        clearTimeout(this.timerId);
        this.timerId = setTimeout(async () => {
          this.recipientLoading = true
          this.recipients = await get(ENDPOINTS.RECIPIENTS + "/" + ENDPOINTS.SEARCH + "/" + query, {funeralhome: true})
          this.recipientLoading = false
        }, 250);
      },
    },
  })
  ;
